// @flow
import { useDrugSelection, withDrugSelection } from '@coverright/widgets';
import * as React from 'react';
import { MedicareQuoteQuery } from '@coverright/data-access/medicare';
import { Button, ButtonBase, Collapse, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { DrugItem } from './drug-item';
import { Portal } from '../../../../../shared';
import { CaretDown } from '@phosphor-icons/react';
import { useState } from 'react';


const View = (props: {quote: MedicareQuoteQuery['medicareQuote']}) => {
  const {drugs, handleAddClick, handleEditClick, handleDeleteClick} = useDrugSelection()
  const [open, setOpen] = useState(false);

  return (<Stack gap={1} flex={1} maxWidth={.5}>
    <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Typography variant={'subtitle1'}>Drugs {!!drugs.length && `(${drugs.length})`}</Typography>
      <Button size={'small'} onClick={handleAddClick}>Add drug</Button>
    </Stack>
    {!!drugs.length && <Portal>
      {drugs.slice(0, 4).map((item, i) => (
        <React.Fragment key={item.packRxcui}>
          <DrugItem drug={item}
                    onDeleteClick={() => handleDeleteClick(item)}
                    onEditClick={() => handleEditClick(item)} />
          {i < drugs.length - 1 && <Divider sx={{}} />}
        </React.Fragment>
      ))}
      {drugs.length > 4 && <>
        <Collapse in={open}>
          {drugs.slice(4).map((item, i) => (
            <React.Fragment key={item.packRxcui}>
              <DrugItem drug={item}
                        onDeleteClick={() => handleDeleteClick(item)}
                        onEditClick={() => handleEditClick(item)} />
              {i < drugs.length - 1 && <Divider sx={{}} />}
            </React.Fragment>
          ))}
        </Collapse>
        <ButtonBase sx={{py: .5, gap: .5}} onClick={() => setOpen(!open)}>
          <Typography variant={'caption'} color={'text.secondary'}>
            Show {open ? 'less' : 'more'}
          </Typography>
          <CaretDown size={12} weight={'bold'} style={{transition: 'all .3s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)'}} />
        </ButtonBase>
      </>}

    </Portal>}
    {!drugs.length && <Stack alignItems={'center'} height={50} justifyContent={'center'}>
      <Typography variant={'body2'} color={'#a5a5a5'}>No drugs added</Typography>
    </Stack>}
  </Stack>);
};

export const Drugs = withDrugSelection(View)

export const DrugsSkeleton = () => (
  <Stack gap={1} flex={1}>
    <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Typography variant={'subtitle1'}>Drugs</Typography>
    </Stack>
    <Portal gap={1} p={2}>
      <Skeleton variant={'rounded'} width={'100%'} height={40} />
      <Skeleton variant={'rounded'} width={'100%'} height={40} />
    </Portal>
  </Stack>
)
